<template>
  <div :style="styles" :class="['svg-icon', 'svg', classList]" v-html="src" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  src?: string;
  width?: string | number;
  height?: string | number;
  solid?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  solid: true,
});

const styles = computed(() => {
  const result: Record<string, string> = {};

  if (props.width) result.width = `${props.width}px`;
  if (props.height) result.height = `${props.height}px`;

  return result;
});

const classList = computed(() => ({
  'set-width': !!styles.value.width,
  'set-height': !!styles.value.height,
  'solid-fill': props.solid,
}));
</script>

<style lang="scss">
.svg-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

svg {
  width: 100%;
  fill: inherit;

  .svg-icon.set-height:not(.set-width) > & {
    width: unset;
  }

  .svg-icon.set-width > & {
    width: 100%;
  }

  .svg-icon.set-height > & {
    height: 100%;
  }

  .svg-icon.solid-fill > & {
    fill: currentColor;

    path,
    ellipse {
      fill: inherit !important;
    }
  }
}
</style>
